import React from 'react';

import { Input, InputWrapper, Optional } from './Input.styles';

const InputComponent = ({
  icon,
  leftIcon,
  type,
  placeholder,
  value,
  disabled,
  onChange,
  className,
  rightIcon,
  optional,
  containerStyle,
  onKeyDown,
  noOpacity,
}) => {
  return (
    <InputWrapper>
      {leftIcon}
      {optional && <Optional>Optional</Optional>}

      <Input
        style={containerStyle}
        className={className}
        $icon={icon}
        $noOpacity={noOpacity}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        onKeyDown={onKeyDown}
      />
      {rightIcon}
    </InputWrapper>
  );
};

export default InputComponent;
